import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { fullAuthGuard } from './core/guards/full-auth.guard';
import { adminGuard } from './core/guards/admin.guard';
import { APP_ROUTES, RouteBuilder } from './core/constants/routes.constants';

export const routes: Routes = [
  {
    path: APP_ROUTES.HOME,
    redirectTo: RouteBuilder.offers(),
    pathMatch: 'full',
  },
  {
    path: APP_ROUTES.OFFERS,
    loadComponent: () =>
      import('./features/offers/offers.component').then(m => m.OffersComponent),
    title: 'Ofertas - Gastronauta',
    data: {
      preload: true, // Ruta crítica - precargar inmediatamente
      header: {
        showLogo: true,
        showNavigation: true,
        showUserActions: true,
        customTitle: 'Ofertas Gastronómicas',
      },
      footer: {
        showFooter: false,
      },
    },
  },
  {
    path: APP_ROUTES.MENUS,
    loadComponent: () =>
      import('./features/menus/menus.component').then(m => m.MenusComponent),
    title: 'Menús - Gastronauta',
    data: {
      preload: true, // Ruta crítica - precargar inmediatamente
      header: {
        showLogo: true,
        showNavigation: true,
        showUserActions: true,
        customTitle: 'Menús del Día',
      },
      footer: {
        showFooter: false,
      },
    },
  },
  {
    path: APP_ROUTES.PLACES,
    loadComponent: () =>
      import('./features/places/places.component').then(m => m.PlacesComponent),
    title: 'Lugares - Gastronauta',
    data: {
      preload: 'delayed', // Ruta secundaria - precargar con delay
      footer: {
        showFooter: false,
      },
    },
  },
  {
    path: APP_ROUTES.LIKED_OFFERS,
    loadComponent: () =>
      import('./features/liked-offers/liked-offers.component').then(
        m => m.LikedOffersComponent
      ),
    // No auth guard - non-logged users can access favorites (stored locally)
    title: 'Favoritos - Gastronauta',
    data: {
      preload: 'delayed', // Ruta secundaria - precargar con delay
      footer: {
        showFooter: false,
      },
    },
  },
  {
    path: APP_ROUTES.SUBMIT_OFFER,
    loadComponent: () =>
      import('./features/submit-offer/submit-offer.component').then(
        m => m.SubmitOfferComponent
      ),
    title: 'Subir Oferta - Gastronauta',
    data: {
      preload: false,
      footer: {
        showFooter: false,
      },
    },
  },
  {
    path: APP_ROUTES.MY_SUBMISSIONS,
    loadComponent: () =>
      import('./features/my-submissions/my-submissions.component').then(
        m => m.MySubmissionsComponent
      ),
    title: 'Mis Envíos - Gastronauta',
    data: {
      preload: false,
      footer: {
        showFooter: false,
      },
    },
  },
  {
    path: APP_ROUTES.SETTINGS,
    loadComponent: () =>
      import('./features/settings/settings.component').then(
        m => m.SettingsComponent
      ),
    canActivate: [authGuard],
    title: 'Configuración - Gastronauta',
    data: { preload: 'delayed' }, // Ruta secundaria - precargar con delay
  },
  {
    path: APP_ROUTES.ADMIN,
    loadChildren: () =>
      import('./features/admin/admin.routes').then(m => m.adminRoutes),
    canActivate: [adminGuard],
    title: 'Administración - Gastronauta',
    data: { preload: 'admin' }, // Solo precargar para usuarios admin
  },
  {
    path: APP_ROUTES.AUTH,
    loadChildren: () =>
      import('./features/auth/auth.routes').then(m => m.authRoutes),
    title: 'Autenticación - Gastronauta',
    data: { preload: false }, // No precargar rutas de auth
  },
  {
    path: APP_ROUTES.NOT_FOUND,
    loadComponent: () =>
      import('./shared/components/not-found/not-found.component').then(
        m => m.NotFoundComponent
      ),
    title: 'Página no encontrada - Gastronauta',
  },
];
